export default __webpack_public_path__ + "static/media/wQ.955f4e49.png";